import React from 'react';
import { ILeadershipTeam } from '@sapientpro/sapientpro-data-models';
import classnames from 'classnames';
import AnimatedTitle from '../../components/AnimatedTitle';
import Img from '../../components/Img';
import styles from './Mentors.module.scss';

type MentorsProps = {
  data: ILeadershipTeam
};
const Mentors = ({ data }: MentorsProps) => (
  <section className={classnames(styles.mentors, 'container')}>
    <h2 className={classnames(styles.title, 'title3')}><AnimatedTitle title={data.title} /></h2>
    {data.description && (
      <p className={classnames(styles.subtitle, 'bodyText')}>
        {data.description}
      </p>
    )}

    <div className={styles.content}>
      {data.team.members.map(mentor => (
        <div
          className={styles.mentor}
          key={mentor.id}
        >
          <div className={styles.mentor__photo}>
            <Img
              src={mentor.image.url}
              alt={mentor.image.alternativeText || mentor.name}
              withPreloader
            />
          </div>
          <div className={styles.mentor__content}>
            <h6 className={styles.mentor__name}>{mentor.name}</h6>
            {mentor.position && <p className={styles.mentor__experience}>{mentor.position}</p>}
            <p className={classnames(styles.mentor__description, 'bodyText')}>{mentor.description}</p>
          </div>
        </div>
      ))}
    </div>

  </section>
);

export default Mentors;
